import {Action, Module, Mutation} from 'vuex-module-decorators'
import store from "@/store";
import {MdbsCore} from "@/api/tsclient";
import BaseModule from "@/store/modules/BaseModule";
import StudyDto = MdbsCore.StudyDto;
import IStudyCreateDto = MdbsCore.IStudyCreateDto;
import IStudyUpdateDto = MdbsCore.IStudyUpdateDto;
import StudyUpdateDto = MdbsCore.StudyUpdateDto;
import StudyCreateDto = MdbsCore.StudyCreateDto;

const studyClient = new MdbsCore.StudyClient();

@Module({namespaced: true, name: 'study', store: store})
export default class StudyModule extends BaseModule {
    study: StudyDto = new StudyDto();

    @Mutation
    setStudy(study: StudyDto) {
        this.study = study;
    }

    @Mutation
    reset() {
        this.study = new StudyDto();
    }

    @Action({rawError: true})
    async loadById(id: string) {
        await this.execute(async () => {
            if (this.study.id != id) {
                // only load if id is different
                this.setStudy(await studyClient.getById(id))
            }
        }).catch(() => this.reset());
    }

    @Action({rawError: true})
    async create(study: IStudyCreateDto) {
        await this.execute(async () => {
            const createdStudy = await studyClient.create(new StudyCreateDto(study))
            this.setStudy(await studyClient.getById(createdStudy.id))
        }).catch();
    }

    @Action({rawError: true})
    async update(study: IStudyUpdateDto) {
        await this.execute(async () => {
            await studyClient.update(study.id, new StudyUpdateDto(study));
            this.setStudy(await studyClient.getById(study.id))
        }).catch();
    }

    @Action({rawError: true})
    async delete(id: string) {
        await this.execute(async () => {
            await studyClient.delete(id);
            this.reset()
        }).catch();
    }
}
